<div class="full" elderWideScrollbar>
  <router-outlet class="router-flex"></router-outlet>
</div>
